"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var ActionSheet = /** @class */ (function (_super) {
    __extends(ActionSheet, _super);
    function ActionSheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionClick = function (item) {
            _this.fire('actionclick', item);
        };
        _this.menuClick = function (item) {
            _this.fire('itemclick', item);
        };
        _this.handleMaskClick = function () {
            _this.fire('close');
        };
        return _this;
    }
    ActionSheet.prototype.renderMenuItem = function () {
        var _this = this;
        return this.props.items.map(function (menu, idx) {
            var _a;
            if (typeof menu === 'string') {
                return omi_1.h("div", { key: idx, onClick: function (_) { return _this.menuClick(menu); }, className: 'm-actionsheet__cell' }, menu);
            }
            var label = menu.label, className = menu.className, others = __rest(menu, ["label", "className"]);
            var cls = omi_1.classNames((_a = {
                    'm-actionsheet__cell': true
                },
                _a[className] = className,
                _a));
            return (omi_1.h("div", __assign({ key: idx }, others, { onClick: function (_) { return _this.menuClick(menu); }, className: cls }), label));
        });
    };
    ActionSheet.prototype.renderActions = function () {
        var _this = this;
        return this.props.actions.map(function (action, idx) {
            var _a;
            var label = action.label, className = action.className, others = __rest(action, ["label", "className"]);
            var cls = omi_1.classNames((_a = {
                    'm-actionsheet__cell': true
                },
                _a[className] = className,
                _a));
            return (omi_1.h("div", __assign({ key: idx, onClick: function (_) { return _this.actionClick(action); } }, others, { className: cls }), label));
        });
    };
    ActionSheet.prototype.render = function () {
        var _a = this.props, show = _a.show, type = _a.type, onClose = _a.onClose, items = _a.items, actions = _a.actions, others = __rest(_a, ["show", "type", "onClose", "items", "actions"]);
        var cls = omi_1.classNames({
            'm-actionsheet': true,
            'm-actionsheet_toggle': show
        });
        var styleType = type ? type : 'ios';
        return (omi_1.h("div", { className: styleType === 'android' ? 'm-skin_android' : '' },
            omi_1.h("div", { class: "mask", style: { display: show ? 'block' : 'none' }, onClick: this.handleMaskClick }),
            omi_1.h("div", __assign({ className: cls }, others),
                omi_1.h("div", { className: "m-actionsheet__menu" }, this.renderMenuItem()),
                omi_1.h("div", { className: "m-actionsheet__action" }, this.renderActions()))));
    };
    ActionSheet.defaultProps = {
        type: '',
        items: [],
        actions: [],
        show: false
    };
    ActionSheet.propTypes = {
        type: String,
        items: Object,
        actions: Object,
        show: Boolean
    };
    ActionSheet.css = css;
    ActionSheet = __decorate([
        omi_1.tag('m-action-sheet')
    ], ActionSheet);
    return ActionSheet;
}(omi_1.WeElement));
var dom;
function actionSheet(options) {
    if (dom) {
        document.body.removeChild(dom);
        dom = null;
    }
    dom = omi_1.render(omi_1.h("m-action-sheet", { items: options.items, onItemClick: options.onItemClick, actions: options.ios ? [{ label: options.cancel ? options.cancel : 'Cancel' }] : [], onClick: close, show: true, type: options.ios ? 'ios' : 'android' }), 'body');
}
exports.default = actionSheet;
function close() {
    if (dom) {
        document.body.removeChild(dom);
        dom = null;
    }
}
